/**
 * Maintenance Mode Page (P20250925-104)
 *
 * Friendly 503 page shown when MAINTENANCE_MODE=true
 */

import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { Wrench, Clock } from 'lucide-react';

export default function Maintenance() {
  return (
    <>
      <Helmet>
        <title>Site Maintenance - Attain Domains</title>
        <meta name="robots" content="noindex,nofollow" />
      </Helmet>

      <div className="min-h-screen bg-background flex items-center justify-center px-4">
        <div className="max-w-md w-full text-center">
          <div className="mb-8 flex justify-center">
            <div className="relative">
              <Wrench className="h-16 w-16 text-primary animate-pulse" />
              <Clock className="h-8 w-8 text-muted-foreground absolute -bottom-1 -right-1" />
            </div>
          </div>

          <h1 className="text-3xl font-bold mb-4 text-foreground">We'll Be Back Shortly</h1>

          <p className="text-muted-foreground mb-6 text-lg">
            Attain Domains is currently undergoing scheduled maintenance to improve your experience.
          </p>

          <div className="bg-muted/30 rounded-lg p-6 mb-6 text-left">
            <p className="text-sm text-muted-foreground mb-2">
              <strong className="text-foreground">Expected downtime:</strong> Less than 10 minutes
            </p>
            <p className="text-sm text-muted-foreground">
              <strong className="text-foreground">Reason:</strong> System upgrades and optimizations
            </p>
          </div>

          <div className="space-y-3">
            <p className="text-sm text-muted-foreground">
              Please check back soon. If you have urgent inquiries:
            </p>
            <Link
              to="/support/contact"
              className="inline-block text-primary hover:underline font-medium"
            >
              Contact Support →
            </Link>
          </div>

          <div className="mt-8 text-xs text-muted-foreground">
            Status page: <span className="font-mono">attaindomains.com/health</span>
          </div>
        </div>
      </div>
    </>
  );
}
